import { Tooltip } from "antd";
import clsx from "clsx";
import {
  StatusSignedIcon,
  StatusPendingIcon,
  StatusDeclinedIcon,
  CommentIcon,
} from "@/shared/assets/svg/icons";
import "./status-with-icon.scss";

const STATUS_MAP = {
  NEW: {
    title: "Новый",
    Icon: null,
  },
  PENDING: {
    title: "Ожидает подписания",
    Icon: StatusPendingIcon,
  },
  DONE: {
    title: "Подписано",
    Icon: StatusSignedIcon,
  },
  REJECTED: {
    title: "Отклонено подписание",
    Icon: StatusDeclinedIcon,
  },
  AWAITING_SIGNATURE: {
    title: "Ожидает подписания",
    Icon: StatusPendingIcon,
  },
  SIGNED: {
    title: "Подписано",
    Icon: StatusSignedIcon,
  },
};

interface StatusWithIconProps {
  status: keyof typeof STATUS_MAP | string;
  comment?: string;
  className?: string;
}

export const StatusWithIcon = ({
  status,
  comment,
  className = "",
}: StatusWithIconProps) => {
  const statusInfo = STATUS_MAP[status as keyof typeof STATUS_MAP];

  if (!statusInfo) {
    return <div className={className}>{status}</div>;
  }

  const { title, Icon } = statusInfo;

  return (
    <span className={clsx("status-with-icon", className)}>
      {Icon && <Icon className="status-with-icon__icon" />}
      <span className="status-with-icon__title">{title}</span>
      {comment && (
        <Tooltip title={comment}>
          <div className="status-with-icon__comment">
            <CommentIcon />
          </div>
        </Tooltip>
      )}
    </span>
  );
};

